import React, { useEffect, useState } from "react";
import * as SettingSelector from "../../../../store/setting/selectors";
import { useSelector } from "react-redux";
import Verticalnav from "./verticalnav";
import Scrollbar from "smooth-scrollbar";
import { Link } from "react-router-dom";

const Sidebar = () => {
  const sidebarType = useSelector(SettingSelector.sidebar_type);
  const sidebarMenuStyle = useSelector(SettingSelector.sidebar_menu_style);
  const appName = useSelector(SettingSelector.app_name);
  const [isCollapsed, setIsCollapsed] = useState(false);

  useEffect(() => {
    Scrollbar.init(document.querySelector(".data-scrollbar"));

    const handleResize = () => {
      const sidebarResponsive = document.querySelector(
        '[data-sidebar="responsive"]'
      );
      if (window.innerWidth < 1025) {
        if (sidebarResponsive !== null) {
          if (!sidebarResponsive.classList.contains("sidebar-mini")) {
            sidebarResponsive.classList.add("sidebar-mini", "on-resize");
            setIsCollapsed(true);
          }
        }
      } else {
        if (sidebarResponsive !== null) {
          if (
            sidebarResponsive.classList.contains("sidebar-mini") &&
            sidebarResponsive.classList.contains("on-resize")
          ) {
            sidebarResponsive.classList.remove("sidebar-mini", "on-resize");
            setIsCollapsed(false);
          }
        }
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Call once to set initial state

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const minisidebar = () => {
    const sidebar = document.getElementsByTagName("ASIDE")[0];
    sidebar.classList.toggle("sidebar-mini");
    setIsCollapsed(sidebar.classList.contains("sidebar-mini"));
  };

  return (
    <>
      <aside
        className={`${sidebarType.join(
          " "
        )} ${sidebarMenuStyle} sidebar sidebar-default sidebar-base navs-rounded-all`}
        id="first-tour"
        data-toggle="main-sidebar"
        data-sidebar="responsive"
      >
        <div className="sidebar-header d-flex align-items-center justify-content-start position-relative">
          <Link
            to="/"
            className="d-flex align-items-center gap-2 iq-header-logo"
            style={{ marginBottom: "10px", marginTop: "10px"}}
          >
            {isCollapsed ? (
              <img src="https://static-00.iconduck.com/assets.00/hpe-icon-512x141-zhwonogp.png" style={{maxWidth: "50px"}} />
            ) : (
              <img src="https://upload.wikimedia.org/wikipedia/commons/4/46/Hewlett_Packard_Enterprise_logo.svg" style={{maxWidth: "150px"}} />
            )}
          </Link>
          <div
            className="sidebar-toggle"
            data-toggle="sidebar"
            data-active="true"
            onClick={minisidebar}
          >
            <span className="menu-btn d-inline-block is-active">
              <i className="right-icon material-symbols-outlined icon-rtl">
                chevron_left
              </i>
            </span>
          </div>
        </div>
        <div className="sidebar-body pt-0 data-scrollbar">
          <div className="sidebar-list">
            <Verticalnav />
          </div>
        </div>
        <div className="sidebar-footer"></div>
      </aside>
    </>
  );
};

export default Sidebar;